import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import autoBind from 'react-autobind';
import Clear from 'material-ui/svg-icons/content/clear';
import {connect} from 'react-redux';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import {isSupportedDevice} from '../../shared/services';
import {loadIdentity} from '../../authentication/actions/creators';
import MenuItem from 'material-ui/MenuItem';
import muiTheme from '../../../styles/teamologyTheme';
import {UserProfileForm} from '../../userProfile/components';
import {white} from 'material-ui/styles/colors';

import {
  closeEditProfileDialog,
  openEditProfileDialog,
  setUserProfileMenuOpenState
} from '../actions';
import {
  getCurrentUserEmail,
  getCurrentUserId,
  getCurrentUserIsAdmin
} from '../../authentication/selectors';
import {Link, withRouter} from 'react-router';
import React, {Component, PropTypes} from 'react';

class UserProfileMenu extends Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
  }

  handleToggleMenu() {
    const {menuIsOpen, setUserProfileMenuOpenState} = this.props;
    setUserProfileMenuOpenState(!menuIsOpen);
  }

  handleItemSelection() {
    const {setUserProfileMenuOpenState} = this.props;
    setUserProfileMenuOpenState(false);
  }

  handleOpenEditProfile() {
    const {router, loadIdentity, openEditProfileDialog} = this.props;
    loadIdentity().then(() => {
      if (isSupportedDevice()) {
        router.push('/edit-profile');
      } else {
        openEditProfileDialog();
      }
    });
  }

  handleRequestMenuOpenChange(openMenu, eventName) {
    // clicking on the menu trigger is handled by the container's onClick with toggleMenu,
    //  only handle closing the menu when the user clicks away here
    if (eventName !== 'clickAway') return;

    const {setUserProfileMenuOpenState} = this.props;
    setUserProfileMenuOpenState(openMenu);
  }

  handleAdminClick() {
    window.location.href = '/admin';
  }

  handleLogoutClick() {
    window.location.href = '/logout';
  }

  render() {
    const labelStyle = {
      color: white,
    };

    const anchorOrigin = {
      vertical: 'bottom',
      horizontal: 'right',
    };

    const targetOrigin = {
      vertical: 'top',
      horizontal: 'right',
    };

    const {
      closeEditProfileDialog,
      editProfileIsOpen,
      userId,
      userIsAdmin
    } = this.props;

    return (
      <div className="user-profile-menu-trigger" onClick={this.handleToggleMenu}>
        <FlatButton className="user-profile-menu-name" label={this.props.userEmail} labelStyle={labelStyle} />
        <IconMenu
          iconButtonElement={<IconButton className="arrow-icon-button"><ArrowDropDown viewBox="0, -5, 24, 24" className="arrow-icon" color={white} /></IconButton>}
          anchorOrigin={anchorOrigin}
          targetOrigin={targetOrigin}
          open={this.props.menuIsOpen}
          onItemTouchTap={this.handleItemSelection}
          onRequestChange={this.handleRequestMenuOpenChange}>
          <MenuItem value="profile" primaryText="My Profile" onTouchTap={this.handleOpenEditProfile} />
          {userIsAdmin ? <MenuItem value="admin" primaryText="Admin" onTouchTap={this.handleAdminClick} /> : null }
          <MenuItem value="logout" primaryText="Logout" onTouchTap={this.handleLogoutClick} />
        </IconMenu>
        <Dialog
          className="edit-user-profile"
          contentStyle={{width: '20%', maxWidth: '20%', minWidth: '330px'}}
          title={
            <div className="title">
              <div>Edit Profile</div>
              <div><IconButton onClick={closeEditProfileDialog} iconStyle={{color: muiTheme.palette.primary1Color}}><Clear /></IconButton></div>
            </div>
            }
          open={editProfileIsOpen}
          bodyStyle={{overflowY: 'scroll'}}
          modal>
          <UserProfileForm userId={`${userId}`} redirectOnSuccess={false} submitText="Submit" />
        </Dialog>
      </div>
    );
  }
}

UserProfileMenu.propTypes = {
  closeEditProfileDialog: PropTypes.func.isRequired,
  editProfileIsOpen: PropTypes.bool.isRequired,
  loadIdentity: PropTypes.func.isRequired,
  menuIsOpen: PropTypes.bool.isRequired,
  openEditProfileDialog: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  setUserProfileMenuOpenState: PropTypes.func.isRequired,
  userEmail: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  userIsAdmin: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  const {userProfileMenu} = state.features.layout;

  return {
    userEmail: getCurrentUserEmail(state),
    userId: getCurrentUserId(state),
    menuIsOpen: userProfileMenu.get('isOpen'),
    editProfileIsOpen: userProfileMenu.get('editProfileIsOpen'),
    userIsAdmin: getCurrentUserIsAdmin(state)
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    closeEditProfileDialog,
    loadIdentity,
    openEditProfileDialog,
    setUserProfileMenuOpenState
  }
)(UserProfileMenu));



// WEBPACK FOOTER //
// ./app/features/layout/components/UserProfileMenu.js